import * as React from "react"
const Rename = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || "currentColor"}
      fillOpacity={1}
      d="M8.71.778A2.562 2.562 0 0 1 11.265.74c.266.148.51.371.788.65l.582.596c.274.284.492.531.635.8a2.67 2.67 0 0 1-.037 2.573c-.202.354-.535.664-.957 1.071L6.79 11.714c-.828.798-1.386 1.353-2.104 1.633-.72.281-1.5.248-2.639.218l-.163-.005c-.16-.004-.36-.007-.528-.035a1.109 1.109 0 0 1-.67-.353 1.124 1.124 0 0 1-.268-.7c-.01-.17.008-.368.02-.533l.016-.202c.078-.997.121-1.67.387-2.283.267-.614.729-1.1 1.4-1.828l5.416-5.868c.398-.431.703-.773 1.051-.98ZM3.344 8.643c-.74.802-.985 1.081-1.127 1.409-.143.328-.182.704-.268 1.801l-.015.203-.001.005.153.004c1.262.033 1.683.03 2.055-.115.373-.146.69-.432 1.608-1.316l4.621-4.453-2.473-2.473-4.553 4.935Zm7.193-6.591a1.062 1.062 0 0 0-1.062.015c-.1.06-.212.168-.558.54l2.532 2.531c.323-.314.424-.422.48-.521.198-.346.204-.774.017-1.126-.065-.12-.189-.259-.673-.754-.486-.496-.62-.622-.736-.685Z"
    />
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={1}
      strokeWidth={1.5}
      d="M8.166 12.833h4.667"
    />
  </svg>
)
export default Rename
